import { Box } from "@mui/material";
import { CardTransactionFilter } from "Components/CardTransactions/CardTransactionFilter";
import { CardTransactionFilterChips } from "Components/CardTransactions/CardTransactionFilterChips";
import type { CardTransactionFilterManager } from "Components/CardTransactions/hooks/useCardTransactionFilterManager";

type Props = {
  filterManager: CardTransactionFilterManager;
};

export const CardTransactionFilterBar = ({ filterManager }: Props) => {
  const { filters, activeFilterCount } = filterManager;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <CardTransactionFilter filterManager={filterManager} />
      <CardTransactionFilterChips
        filters={filters}
        isVisible={activeFilterCount > 0}
      />
    </Box>
  );
};
